'use client';

import ArticleDetail from '@/components/article-detail';
import { EventBreadcrumbItems } from '@/data/globals.data';

export default function Client() {
  return <ArticleDetail breadcrumbItems={EventBreadcrumbItems} />;
}
